var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.representation)?_c('span',[_c('v-icon',{staticClass:"fielddate-calendar-icon",attrs:{"small":""}},[_vm._v("\n      mdi-calendar\n    ")]),_c('span',{class:_vm.class_limit_time,staticStyle:{"padding-left":".2em"}},[_vm._v(_vm._s(_vm.representation))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }